<template>
  <div class="add_drug_pages">
    <div v-wechat-title="$route.meta.title"></div>
    <!-- <div >{{myres}}</div> -->
    <van-tabs
      :line-width="'10px'"
      color="#333"
      title-active-color="#333"
      title-style="font-size:30px"
      title-inactive-color="#999999"
      @click="tabsChange"
      v-model="tabStatus"
      :border="false"
      :sticky="true"
    >
      <van-tab title="搜索添加">
        <div class="search_add">
          <img v-if="hasScan ==true" class="search_add_img" @click="to_scan" src="../images/扫码.png" alt />
          <van-search
            :class="hasScan ==true?'sear_pos':'sear_pos2'"
            placeholder="请输入通用名搜索"
            show-action
            type="search"
            v-model="searchValue"
            @search="search(1)"
            @focus="inputFocus"
            @blur="inputBlur"
          >
            <div slot="action" @click="search(1)">搜索</div>
          </van-search>
          <van-list v-model="loading" :finished="finished" @load="search" style="min-height=100%;">
            <div class="drugList" >
              <div
                class="flex1 drug_item"
                v-for="(item,index) in searchList"
                :key="item.name"
              >
                <div>
                  <div class="drug_title">{{item.ComName}}</div>
                  <h4 class="drug_spc">{{item.Specs}}</h4>
                  <!-- <h4 class="drug_company van-ellipsis">{{item.FactoryName}}</h4> -->
                </div>
                <div class="flex2">
                  <img
                    src="@/images/reduce.png"
                    v-if="item.num!=0&&!isOnlyOne"
                    class="drug_reduce_btn"
                    @click="reduceDrug({index:index,num:item.num,type:1,id:item.DrugId})"
                  />

                  <input
                    type="number"
                    v-model="item.num"
                    class="drug_num"
                    maxlength="2"
                    @input="getNum(index,item.num)"
                    @blur="aways(index)"
                    v-if="item.num!=0&&!isOnlyOne"
                    disabled
                  />
                  <img
                    src="@/images/plus.png"
                    class="drug_add_btn"
                    @click="addDrug({index:index,num:item.num,type:1,id:item.DrugId})"
                    v-if="!isOnlyOne"
                  />
                </div>
              </div>

              <div class="no_drug_module" v-if="addTip">
                <img src="@/images/search_null.png" class="no_data_img" />
                <div class="search_tip">搜索不到该商品，您可以联系对接的商务人员添加</div>
                <!-- <div class="goto_add_btn" @click="gotoAdd">新增药品</div> -->
              </div>
            </div>
            <div class="search_tip_ming" v-if="searchList == '' && !addTip ">请扫码或搜索通用名规格添加药品</div>
          </van-list>
        </div>

        <div
          :class="focus?'flex1 add_arug_footer add_drug_position_abs':'flex1 add_arug_footer'"
          v-if="!isOnlyOne"
        >
          <div class="pos1" @click="changeCarType">
            <div class="add_arug_select_img">
              <img src="@/images/add_drug.png" class="add_arug_img" />
            </div>
            <h4>已选药品</h4>
            <div class="add_arug_num" v-if="shopCarList.length!=0">{{shopCarList.length}}</div>
          </div>
          <div class="add_arug_add_drug" @click="subMitAdd">确定添加</div>
        </div>
      </van-tab>
      <van-tab title="添加记录">
        <div class="history_module">
          <div
            class="flex1 drug_item"
            v-for="(item,index) in addHis"
            :key="item.name"
          >
            <div>
              <div class="drug_title van-ellipsis">{{item.ComName}}</div>
              <h4 class="drug_spc">{{item.Specs}}</h4>
              <h4 class="drug_company van-ellipsis">{{item.FactoryName}}</h4>
            </div>
            <div class="flex2">
              <img
                src="@/images/reduce.png"
                v-if="item.num!=0&&!isOnlyOne"
                @click="hisReduceDrug({index:index,num:item.num,type:1,id:item.DrugId})"
                class="drug_reduce_btn"
              />
              <input
                type="number"
                v-model="item.num"
                class="drug_num"
                maxlength="2"
                @input="getNum(index,item.num)"
                @blur="aways(index)"
                v-if="item.num!=0&&!isOnlyOne"
                disabled
              />
              <img
                src="@/images/plus.png"
                class="drug_add_btn"
                @click="hisAddDrug({index:index,num:item.num,type:1,id:item.DrugId})"
                v-if="!isOnlyOne"
              />
            </div>
          </div>

          <div class="trans" v-if="addHis.length==0">
            <img src="@/images/no_history.png" />
            <div class>暂无添加记录</div>
          </div>
          <div
            :class="focus?'flex1 add_arug_footer add_drug_position_abs':'flex1 add_arug_footer'"
            v-if="!isOnlyOne"
          >
            <div class="pos1" @click="changeCarType">
              <div class="add_arug_select_img">
                <img src="@/images/add_drug.png" class="add_arug_img" />
              </div>
              <h4>已选药品</h4>
              <div class="add_arug_num" v-if="shopCarList.length!=0">{{shopCarList.length}}</div>
            </div>
            <div class="add_arug_add_drug" @click="subMitAdd">确定添加</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <!-- 购物车组件 -->
    <van-popup v-model="shopCar" class="shopCar" position="bottom">
      <div class="select_tip pos1">
        <div>已选择药品</div>
        <div class="flex2 deleteAll" @click="deleteAll">
          <div class="add_me_delete_img">
            <img src="@/images/trash_can.png" />
          </div>
          <div>清空</div>
        </div>
      </div>
      <div class="itemList">
        <div class="flex1 drug_item" v-for="(item,index) in shopCarList" :key="item.name">
          <div>
            <div class="drug_title van-ellipsis">{{item.ComName}}</div>
            <h4 class="drug_spc">{{item.Specs}}</h4>
            <!-- <h4 class="drug_company van-ellipsis">{{item.FactoryName}}</h4> -->
          </div>
          <div class="flex2">
            <img
              src="@/images/reduce.png"
              class="drug_reduce_btn"
              @click="reduceDrug({index:index,num:item.num,type:2,id:item.DrugId})"
              v-if="!isOnlyOne"
            />
            <input
              type="number"
              v-model="item.num"
              class="drug_num"
              maxlength="2"
              @input="getNum(index,item.num)"
              @blur="aways(index)"
              disabled
              v-if="!isOnlyOne"
            />
            <img
              src="@/images/plus.png"
              class="drug_add_btn"
              @click="addDrug({index:index,num:item.num,type:2,id:item.DrugId})"
            />
          </div>
        </div>
      </div>
      <div
            :class="focus?'flex1 add_arug_footer add_drug_position_abs':'flex1 add_arug_footer'"
            v-if="!isOnlyOne"
          >
            <div class="pos1" @click="changeCarType">
              <div class="add_arug_select_img">
                <img src="@/images/add_drug.png" class="add_arug_img" />
              </div>
              <h4>已选药品</h4>
              <div class="add_arug_num" v-if="shopCarList.length!=0">{{shopCarList.length}}</div>
            </div>
            <div class="add_arug_add_drug" @click="subMitAdd">确定添加</div>
          </div>
    </van-popup>

    <div class="more_modules" v-if="showAdd2">
      <div clas>已经到底了，如找不到该商品，您可以联系对接的商务人员添加</div>
      <!-- <div class="goto_add_btn goto_add_btn2" @click="gotoAdd">新增</div> -->
    </div>
  </div>
</template>

<script>
import { Toast, Dialog, Tab, Tabs } from "vant";
import navTab from "@/components/NavigationBar.vue";
import {
  GetDrugList,
  GetUsedDrugsList,
  GetDiagnoseByComNames
} from "@/utils/api.js";
import { cloneObj, getCookie } from "@/utils/common.js";
export default {
  name: "add",
  components: {
    navTab
  },
  data() {
    return {
      hasScan:true,
      myres: "11",
      showaaa: false,
      UpcCode: [], //条形码
      backing: false,
      showAdd2: false,
      Page: 1,
      loading: false,
      finished: true,
      onlyDrugsList: [],
      uniteDrugsList: [],
      isOnlyOne: true, //既往用药
      focus: false, //搜索框是否聚焦
      navStatus: 0,
      addHis: [
        // {
        //   ComName: "明康欣 阿达帕林凝胶",
        //   DrugId: "123451116",
        //   FactoryName: "四川明鑫药业有限公司",
        //   Specs: "15g/支",
        //   Unit: "盒",
        //   num: 1
        // },
        // {
        //   ComName: "ss dsadsa",
        //   DrugId: "1234222256",
        //   FactoryName: "sssssss",
        //   Specs: "15g/支",
        //   Unit: "盒",
        //   num: 1
        // }
      ],
      addTip: false,
      shopCar: false, //是否显示购物车
      tabStatus: 0, //tab下标
      searchValue: "", //搜索框
      searchList: [],
      // 已添加药品列表
      shopCarList: [],
      tabList: [
        {
          text: "搜索添加",
          id: 1
        },
        {
          text: "添加记录",
          id: 2
        }
      ]
    };
  },
  methods: {
    // 扫码
    to_scan() {
      if (this.shopCarList.length == 5) {
        Toast("最多添加5种药品");
        return;
      }

      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      //console.log("appToken过期，开始调用app方法")
      let text = "";
      let count = 0; //剩余可扫码的数量
      count = 4 - this.shopCarList.length;
      let type = 2; //条形码
      this.UpcCode = []
      for (var i = 0; i < this.shopCarList.length; i++) {
        if (this.shopCarList[i].UpcCode != "") {
          this.UpcCode.push(this.shopCarList[i].UpcCode);
        }
      }
      //判断既往用药中是否存在
      // if (this.onlyDrugsList.length != 0) {
      //   if (this.onlyDrugsList[0].UpcCode != 0) {
      //     this.UpcCode.push(this.onlyDrugsList[0].UpcCode);
      //   }
      // }
      // 去重
      for (var i = 0; i < this.UpcCode.length; i++) {
        for (var j = i + 1; j < this.UpcCode.length; j++) {
          if (this.UpcCode[i] == this.UpcCode[j]) {
            //如果第一个等于第二个，splice方法删除第二个
            this.UpcCode.splice(j, 1);
            j--;
          }
        }
      }
      // alert(this.UpcCode);
      //既往用药传1,联合用药传2
      let params = {
        type: 2,
        count: 5 - this.shopCarList.length,
        selected: this.UpcCode
      };
      let params2 = {
        type: 2,
        count: 5 - this.shopCarList.length,
        selected: this.UpcCode
      };
      console.log(JSON.stringify(params));

      if (isAndroid) {
        //console.log("调用了安卓的方法")
        if (this.isOnlyOne) {
          window.jsObj.cameraScan(JSON.stringify(params2));
          // alert(1)
        } else {
          window.jsObj.cameraScan(JSON.stringify(params));
          // alert(2)
        }
      } else if (isiOS) {
        //console.log("调用了IOS的方法")
        if (this.isOnlyOne) {
          window.webkit.messageHandlers.cameraScan.postMessage(
            JSON.stringify(params2)
          );
        } else {
          window.webkit.messageHandlers.cameraScan.postMessage(
            JSON.stringify(params)
          );
        }
        // window.webkit.messageHandlers.cameraScan.postMessage(2);
        //console.log("进入catch")
      }
    },
    // 历史用药添加药品
    selectAndGoback(item) {
      // alert(item)
      // debugger
      // alert("这是复合用药");
      // alert(JSON.stringify(item));
      // if (!this.isOnlyOne) return;
      // if (this.backing) return;
      console.log(111);

      let count = 0;
      // alert(this.uniteDrugsList); 
      // this.uniteDrugsList.map(items => {
      //   if (items.DrugId == item.DrugId) {
      //     Toast("联合用药中已存在此药品");
      //     count++;
      //   }
      // });
      // if (count != 0) return;
      if(this.uniteDrugsList.length==5){
        Toast("最多只能添加五种药品");
      }
      console.log(222);

      // this.backing = true;
      let fillData = JSON.parse(sessionStorage.getItem("fillData"));
      item.map(i=>{
        i.IsMain = 0;
        i.num = 1;
      })
      // this.shopCarList = fillData.addDrugsList;
      // debugger
      // if(item.length==1){
        // this.shopCarList.push(item[0]);
      // }else{
        this.shopCarList = fillData.addDrugsList.concat(item)
      // }
      fillData.addDrugsList = this.shopCarList;

      let arrs = fillData.diseaseList.filter(item => item.sys == false);
      fillData.diseaseList = [];
      // alert(JSON.stringify(fillData));
      // debugger

      GetDiagnoseByComNames({
        commonName: item[0].ComName,
        sex: this.$route.query.sex == "男" ? 1 : 2,
        birthday: this.$route.query.birthday
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);

          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.map(item => {
              item.sys = true;
              item.sel = false;
              fillData.diseaseList.unshift(item);
            });
          }
          fillData.diseaseList = [...fillData.diseaseList, ...arrs];
          sessionStorage.setItem("fillData", JSON.stringify(fillData));
          // this.$router.go(-1);
          // return;
        }
        Toast(res.msg);
      });
    },
    onSubmit() {},
    inputFocus() {
      console.log(13);
      this.focus = true;
    },
    inputBlur() {
      this.focus = false;
    },
    gotoAdd() {
      // let fillData = JSON.parse(sessionStorage.getItem("fillData"))
      // if(fillData){
      //   fillData.diseaseList = this.shopCarList||[]
      //   sessionStorage.setItem("fillData",fillData)
      // }
      this.$router.push({
        path: "/adddrug",
        query: {
          onlyOne: this.$route.query.onlyOne
        }
      });
    },
    // 添加记录中点击减少
    hisReduceDrug(data) {
      if (data.num == 1) {
        Dialog.confirm({
          title: "删除药品",
          message: "确认要删除该药品吗？"
        })
          .then(() => {
            let id = data.id;
            this.addHis.map((item, index) => {
              if (item.DrugId == id) {
                console.log("添加记录中存在");
                item.num = 0;
                this.addHis.splice(index, 1);
              }
            });

            this.shopCarList.map((item, index) => {
              if (item.DrugId == id) {
                console.log("购物车存在相同的药品");
                this.shopCarList.splice(index, 1);
              }
            });
            this.searchList.map(item => {
              if (item.DrugId == id) {
                console.log("搜索列表中存在相同的药品");
                item.num = 0;
              }
            });

            Toast("删除成功");
          })
          .catch(() => {
            console.log("取消删除");
            return;
          });
      } else {
        console.log(data);
        // if (data.type == 1) {
        let id = data.id;
        this.shopCarList.map((item, index) => {
          if (item.DrugId == id) {
            console.log("购物车存在该商品");
            item.num -= 1;
          }
        });
        let fillData = JSON.parse(sessionStorage.getItem("fillData"));
      fillData.addDrugsList = this.shopCarList
      sessionStorage.setItem("fillData", JSON.stringify(fillData));
        this.searchList.map((item, index) => {
          if (item.DrugId == id) {
            console.log("搜索列表存在该商品");
            item.num -= 1;
          }
        });
        this.addHis[data.index].num -= 1;
        // }
        // else if (data.type == 2) {
        //   // 判断搜索结果中是否存在改药品
        //   let id = data.id;
        //   let count = 0;
        //   this.addHis.map(item => {
        //     if (item.DrugId == id) {
        //       //如果存在改药品
        //       console.log("搜索结果存在该商品");
        //       item.num -= 1;
        //     }
        //   });
        //   this.shopCarList[data.index].num -= 1;
        // }
      }
    },
    hisAddDrug(data) {
      if (data.num == 99) {
        Toast("最大数量为99");
        return;
      }
      if (this.shopCarList.length >= 5) {
        let count = 0;
        this.shopCarList.map(item => {
          if (item.DrugId != data.id) {
            count++;
          }
        });
        if (count == 5) {
          Toast("最多添加5种药品");
          return;
        }
      }
      if (this.onlyDrugsList.length != 0) {
        console.log(this.onlyDrugsList[0].DrugId);
        if (data.id == this.onlyDrugsList[0].DrugId) {
          Toast("既往用药中已存在此药品");
          return;
        }
      }
      let id = data.id;
      let count = 0;
      // 判断购物车中是否有该药品
      this.shopCarList.map(item => {
        if (item.DrugId == id) {
          //如果存在改药品
          console.log("购物车存在该商品");
          item.num += 1;
          count++;
        }
      });

      // 判断搜索列表中是否存在该药品
      this.searchList.map(item => {
        if (item.DrugId == id) {
          //如果存在改药品
          console.log("判断搜索列表中存在该商品");
          //
          item.num += 1;
        }
      });
      this.addHis[data.index].num += 1;
      // 如果不存在改药品
      if (!count) {
        // this.shopCarList.push(cloneObj(this.addHis[data.index]));
        console.log(this.addHis[data.index])
        this.shopCarList.push({...this.addHis[data.index]});
        this.shopCarList.map(item => (item.IsMain = 0));
        console.log(this.shopCarList);
      }
      let fillData = JSON.parse(sessionStorage.getItem("fillData"));
      fillData.addDrugsList = this.shopCarList
      sessionStorage.setItem("fillData", JSON.stringify(fillData));
    },
    // 失去焦点的时候，如果还没有进行输入，就提示用户是否进行删除
    aways(i) {
      console.log("失去焦点");
      console.log(this.shopCarList[i].num);
      if (this.shopCarList[i].num == "") {
        this.reduceDrug({
          index: i,
          num: 1
        });
      }
    },
    getNum(i, num) {
      // console.log(num)
      if (num > 99) {
        this.shopCarList[i].num = 99;
      }
      // 如果不是整数
      if (num % 1 != 0) {
        console.log("不等于整数");
        this.shopCarList[i].num = parseInt(this.shopCarList[i].num);
      }
      if (num == 0 && num != "") {
        console.log(this);
        this.reduceDrug({
          num: 1,
          index: i
        });
      }
    },
    // 确定添加按钮
    subMitAdd() {
      // let fillData = JSON.parse(sessionStorage.getItem("fillData"));
      // let items=fillData.addDrugsList.filter(item=>item.IsMain==1)
      // if(items.length!=0){
      //   console.log(items)
      //   this.shopCarList.push(items[0])
      // }
      // fillData.addDrugsList = this.shopCarList;
      // sessionStorage.setItem("fillData", JSON.stringify(fillData));
      console.log(this.shopCarList);
      // return
      let commonName = ''
      this.shopCarList.map(item=>{
        commonName += item.ComName + '|'
      })
      console.log(commonName);
      // return
      let fillData = JSON.parse(sessionStorage.getItem("fillData"));
      // item.IsMain = 1;
      // item.num = 1;
      // this.shopCarList = fillData.addDrugsList.filter(item => item.IsMain == 0);
      // debugger
      // this.shopCarList.push(item);
      fillData.addDrugsList = this.shopCarList;

      let arrs = fillData.diseaseList.filter(item => item.sys == false);
      fillData.diseaseList = [];
      GetDiagnoseByComNames({
        commonName,
        sex: this.$route.query.sex == "男" ? 1 : 2,
        birthday: this.$route.query.birthday
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          // debugger
          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.map(item => {
              item.sys = true;
              item.sel = false;
              fillData.diseaseList.unshift(item);
            });
          }
          fillData.diseaseList = [...fillData.diseaseList, ...arrs];
          sessionStorage.setItem("fillData", JSON.stringify(fillData));
          this.$router.go(-1);
          return;
        }
        Toast(res.msg);
      })
      .catch(err=>{
        console.log(err);
      })
      // this.$router.go(-1);
    },
    // 搜索框搜索
    search(data) {
      this.showAdd2 = false;
      console.log(data);
      if (!this.searchValue) {
        return;
      }
      if (data) {
        this.Page = 1;
      }
      this.addTip = false;
      console.log(this.$store.state.AppKey);
      // upcCode:"",
      GetDrugList({
        commonName: this.searchValue,
        pageIndex: this.Page,
        pageSize: 20
      }).then(res => {
        if (res.code == 1) {
          if (res.data.list.length == 0) this.addTip = true;
          res.data.list.map(item => {
            item.num = 0;
          });
          this.shopCarList.map(item => {
            res.data.list.map(items => {
              if (item.DrugId == items.DrugId) {
                console.log("相同");
                items.num = JSON.parse(JSON.stringify(item.num));
              }
            });
          });
          // 如果是点击搜索或者键盘搜索，清空数组
          if (data) {
            this.searchList = [];
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }

          this.searchList = [...this.searchList, ...res.data.list];
          this.Page++;
          if (this.searchList.length >= res.data.total) {
            this.finished = true;
            if (this.searchList.length > 0) {
              this.showAdd2 = true;
            }
          } else {
            this.finished = false;
          }
          this.loading = false;
        } else {
          this.addTip = true;
          this.searchList = []
        }
      });
      // this.addTip = true;
    },
    // 显示和隐藏购物车
    changeCarType() {
      this.shopCar = !this.shopCar;
    },
    // 减少数量
    reduceDrug(data) {
      console.log(data);
      let id = data.id;
      if (data.num == 1) {
        Dialog.confirm({
          title: "删除药品",
          message: "确认删除该药品吗？"
        })
          .then(() => {
            console.log(id);
            this.searchList.map((item, index) => {
              if (item.DrugId == id) {
                console.log("搜索列表存在相同的药品");
                item.num = 0;
              }
            });
            this.addHis.map((item, index) => {
              if (item.DrugId == id) {
                console.log("添加记录中存在相同的药品");
                item.num = 0;
              }
            });
            this.shopCarList.map((item, index) => {
              if (item.DrugId == id) {
                console.log("购物车存在相同的药品");
                this.shopCarList.splice(index, 1);
              }
            });
            let fillData = JSON.parse(sessionStorage.getItem('fillData'))
            fillData.addDrugsList = this.shopCarList
            sessionStorage.setItem("fillData", JSON.stringify(fillData));

            Toast("删除成功");
            return;
          })
          .catch(() => {
            console.log("取消删除");
            return;
          });
      } else {
        // 点击搜索列表中的 减 少
        if (data.type == 1) {
          this.shopCarList.map((item, index) => {
            if (item.DrugId == id) {
              console.log("购物车存在该商品");
              this.shopCarList[index].num -= 1;
            }
          });
          this.addHis.map(item => {
            if (item.DrugId == id) {
              console.log("添加记录中存在该商品");
              item.num -= 1;
            }
          });
          this.searchList[data.index].num -= 1;
          // 点击购物车中的 减少
        } else if (data.type == 2) {
          // 判断搜索结果中是否存在改药品
          this.searchList.map(item => {
            if (item.DrugId == id) {
              //如果存在改药品
              console.log("搜索结果存在该商品");
              item.num -= 1;
            }
          });

          this.addHis.map(item => {
            if (item.DrugId == id) {
              //如果存在改药品
              console.log("添加历史存在该商品");
              item.num -= 1;
            }
          });
          this.shopCarList[data.index].num -= 1;
        }
          let fillData = JSON.parse(sessionStorage.getItem("fillData"));
          fillData.addDrugsList = this.shopCarList
          sessionStorage.setItem("fillData", JSON.stringify(fillData));
      }
    },
    // 增加数量
    addDrug(data) {
      if (data.num == 99) {
        Toast("最大数量为99");
        return;
      }

      if (this.shopCarList.length >= 5) {
        let count = 0;
        this.shopCarList.map(item => {
          if (item.DrugId != data.id) {
            count++;
          }
        });
        if (count == 5) {
          Toast("最多添加5种药品");
          return;
        }
      }
      // 判断既往用药中是否存在该药品
      if (this.onlyDrugsList.length != 0) {
        console.log(this.onlyDrugsList[0].DrugId);
        if (data.id == this.onlyDrugsList[0].DrugId) {
          Toast("既往用药中已存在此药品");
          return;
        }
      }

      //type: 1为点击搜索的+号，2为点击购物车上的+号
      if (data.type == 1) {
        if (this.shopCarList.length == 0) {
          this.addHis.map(item => {
            if (item.DrugId == data.id) {
              item.num++;
            }
          });
          console.log(data);
          this.searchList[data.index].num += 1;
          // alert(this.searchList[data.index]);
          this.shopCarList.push(cloneObj(this.searchList[data.index]));
          this.shopCarList[0].IsMain = 0;
        } else {
          let id = data.id;
          let count = 0;
          // 判断购物车中是否有改药品
          this.shopCarList.map(item => {
            if (item.DrugId == id) {
              //如果存在此药品
              console.log("购物车存在该商品");
              // this.searchList[data.index].num += 1;
              item.num += 1;
              count++;
            }
          });
          // 如果不存在改药品

          // 判断添加记录是否存在此药品
          let count2 = 0;
          this.addHis.map(item => {
            // 如果存在
            if (item.DrugId == data.id) {
              item.num++;
              count2++;
            }
          });

          this.searchList[data.index].num += 1;
          if (!count) {
            // this.searchList[data.index].num += 1;
            this.shopCarList.push(cloneObj(this.searchList[data.index]));
            this.shopCarList.map(item => (item.IsMain = 0));
          }
        }
      } else if (data.type == 2) {
        // 判断搜索结果中是否存在改药品
        let id = data.id;
        this.searchList.map(item => {
          if (item.DrugId == id) {
            //如果存在改药品
            console.log("搜索结果存在该商品");
            item.num += 1;
          }
        });

        this.addHis.map(item => {
          if (item.DrugId == id) {
            //如果存在改药品
            console.log("添加结果存在该商品");
            item.num += 1;
          }
        });
        this.shopCarList[data.index].num += 1;
      }
      let fillData = JSON.parse(sessionStorage.getItem("fillData"));
      fillData.addDrugsList = this.shopCarList
      sessionStorage.setItem("fillData", JSON.stringify(fillData));
    },
    // 点击导航栏
    tabsChange(index) {
      // console.log(index);
      // console.log(this.tabStatus);
      if (this.navStatus == index) return;
      if (index == 0) return;
      this.navStatus = index;
      this.getList();
    },
    deleteAll() {
      Dialog.confirm({
        title: "清空药品",
        message: "确认清空药品吗？"
      })
        .then(() => {
          let fillData = JSON.parse(sessionStorage.getItem('fillData'))
          fillData.addDrugsList = []
          sessionStorage.setItem("fillData", JSON.stringify(fillData));
          this.shopCarList = [];
          this.searchList.map(item => {
            item.num = 0;
          });
          this.addHis.map(item => {
            item.num = 0;
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getList() {
      GetUsedDrugsList({}).then(res => {
        if (res.code == 1) {
          console.log(res);

          res.data.list.map(item => {
            item.num = 0;
          });
          this.shopCarList.map(item => {
            res.data.list.map(items => {
              if (item.DrugId == items.DrugId) {
                items.num = JSON.parse(JSON.stringify(item.num));
              }
            });
          });
          this.addHis = res.data.list;
        }
      });
    }
  },
  created() {
    document.title = this.$route.meta.title;
  },
  mounted() {
    this.myres = this.shopCarList;
    let that = this;
    window.cameraScanResult = function(type, res) {
      that.$forceUpdate();
      let item = JSON.parse(res);
      // that.showaaa = JSON.parse(res);
      // that.myres = item.length
      // alert(item)
      console.log(item);
      if (that.isOnlyOne) {
        for (var i = 0; i < item.length; i++) {
          item[i].num = 1;
        }
        // if (that.shopCarList.length >= 4) {
        //   let count = 0;
        //   that.shopCarList.map(item => {
        //     if (item.DrugId != data.id) {
        //       count++;
        //     }
        //   });
        //   if (count == 4) {
        //     Toast("最多添加4种药品");
        //     return;
        //   }
        // }
        // 判断既往用药中是否存在该药品
        if (that.onlyDrugsList.length != 0) {
          console.log(that.onlyDrugsList[0].DrugId);
          // if (item.DrugId == that.onlyDrugsList[0].DrugId) {
          //   Toast("既往用药中已存在此药品");
          //   return;
          // }
          if (that.shopCarList.length == 0) {
            // that.addHis.map(item1 => {
            //   if (item1.DrugId == item.DrugId) {
            //     item1.num++;
            //   }
            // });
            // console.log(data);
            // that.searchList[data.index].num += 1;
            // alert(that.searchList[data.index]);
            for (var i = 0; i < item.length; i++) {
              that.shopCarList.push(item[i]);
            }
            // that.shopCarList.push(cloneObj(item));
            that.shopCar = true;
            for (var i = 0; i < that.shopCarList.length; i++) {
              that.shopCarList[i].IsMain = 0;
            }
          } else {
            let id = item.DrugId;
            let count = 0;
            // 判断购物车中是否有改药品
            that.shopCarList.map(item2 => {
              if (item2.DrugId == id) {
                //如果存在此药品
                console.log("购物车存在该商品");
                that.shopCar = true;
                // that.searchList[data.index].num += 1;
                item2.num += 1;
                count++;
              }
            });
            // 如果不存在改药品

            // 判断添加记录是否存在此药品
            let count2 = 0;
            that.addHis.map(item3 => {
              // 如果存在
              if (item3.DrugId == item.DrugId) {
                item3.num++;
                count2++;
              }
            });

            // that.searchList[data.index].num += 1;
            if (!count2) {
              // that.searchList[data.index].num += 1;
              // that.shopCarList.push(cloneObj(item));
              for (var i = 0; i < item.length; i++) {
                that.shopCarList.push(item[i]);
              }
              that.shopCar = true;
              that.shopCarList.map(item4 => (item4.IsMain = 0));
            }
          }
        }
      }
      that.selectAndGoback(item);
    };

     if(getCookie('version')){
       var version = getCookie('version').split('.')
      console.log(version);
      if( (version[0] == 3 && version[1] == 1) || (version[0] > 3) || (version[0] == 3 && version[1] > 1) ){
        this.hasScan = true
      } else {
        this.hasScan = false
      }
     }
    

    window.watchs();
    console.log(this.$route.query);
    // sessionStorage.setItem("his",true)
    this.isOnlyOne = this.$route.query.onlyOne == true ? true : false;
    if (this.$route.query.onlyOne == true) this.isOnlyOne = true;
    if (this.$route.query.onlyOne == "true") this.isOnlyOne = true;
    if (this.$route.query.onlyOne == false) this.isOnlyOne = false;
    if (this.$route.query.onlyOne == "false") this.isOnlyOne = false;
    // alert(this.isOnlyOne);

    console.log(window.history);
    if (sessionStorage.getItem("fillData")) {
      let arr = JSON.parse(sessionStorage.getItem("fillData")).addDrugsList;
      if (this.isOnlyOne) {
        this.shopCarList = arr.filter(item => item.IsMain == 1);
      } else {
        this.shopCarList = arr.filter(item => item.IsMain == 0 || !item.IsMain);
      }
      this.onlyDrugsList = arr.filter(item => item.IsMain == 1);
      this.uniteDrugsList = arr.filter(
        item => item.IsMain == 0 || !item.IsMain
      );
    }
  },
  beforeDestroy() {
    console.log(this.shopCarList);
    // alert(JSON.stringify(this.shopCarList));
    // let fillData = JSON.parse(sessionStorage.getItem("fillData"));
    // fillData.addDrugsList = this.shopCarList;
    // console.log(fillData.addDrugsList);
    // sessionStorage.setItem("fillData", JSON.stringify(fillData));

    if (!this.isOnlyOne) {
      let fillData = JSON.parse(sessionStorage.getItem("fillData"));
      let items = fillData.addDrugsList.filter(item => item.IsMain == 1);
      if (items.length != 0) {
        console.log(items);
        this.shopCarList.push(items[0]);
      }
      fillData.addDrugsList = this.shopCarList;
      sessionStorage.setItem("fillData", JSON.stringify(fillData));
    }
  }
};
</script>

<style lang="scss" scoped="scoped" src="@/scss/add_medicine.scss">
</style>
<style >
.van-ellipsis {
  font-size: 13px ;
  font-weight: 400;
}
.van-tab--active {
  font-size: 16px ;
  font-weight: 600;
  font-family: PingFang SC;
}
</style>
